import { init_state } from "./reducer";

export default {
  reducer_setPhoneData(state, data) {
    return {
      ...state,
      login: data,
    };
  },
  reducer_setToken(state, data) {
    return {
      ...state,
      token: data.token,
    };
  },
  reducer_setProfile(state, profile) {
    if (!state.token) {
      return state;
    }

    return {
      ...state,
      profile,
    };
  },
  reducer_setGroups(state, groups) {
    if (!state.token) {
      return state;
    }

    return {
      ...state,
      groups,
    };
  },
  reducer_setSelectedGroup(state, selectedGroup) {
    if (!state.token) {
      return state;
    }

    return {
      ...state,
      selectedGroup,
    };
  },

  reducer_user_address(state, data: any[]) {
    if (!state.token) {
      return state;
    }

    return { ...state, address: data };
  },

  reducer_add_single_address(state, data: any[]) {
    let addresses = JSON.parse(JSON.stringify(state.address));
    addresses.push(data);
    return {
      ...state,
      address: addresses,
    };
  },

  reducer_set_orders(state, data) {
    if (!state.token) {
      return state;
    }

    let orders = state.orders ? JSON.parse(JSON.stringify(state.orders)) : [];

    if (Array.isArray(data)) orders = data;
    else orders.push(data);

    return {
      ...state,
      orders,
    };
  },

  reducer_set_transactions(state, data) {
    let transactions = state.transactions
      ? JSON.parse(JSON.stringify(state.transactions))
      : [];
    if (Array.isArray(data)) transactions = data;
    else transactions.push(data);
    return {
      ...state,
      transactions,
    };
  },

  reducer_set_reset(state) {
    return {
      ...state,
      login: {
        ...state.login,
        meta: undefined,
      },
    };
  },

  reducer_delete_address(state, data) {
    if (state.address) {
      return {
        ...state,
        address: state.address.filter((item) => item.id !== data.address_id),
      };
    }
    return state;
  },

  reducer_edit_profile(state, data) {
    if (data) {
      return {
        ...state,
        profile: {
          ...state.profile,
          ...data,
        },
      };
    }
    return state;
  },
  reducer_orders_needs_action(state, data) {
    if (data) {
      return {
        ...state,
        orders_needs_action: {
          data,
          lastRetrieve: new Date(),
        },
      };
    }
    return state;
  },
  reducer_logout_user() {
    return init_state;
  },
};
